export default "__VITE_ASSET__DlsnFy0R__"